import type { CatalogTree } from '../types';

export const integrations = {
  title: 'Entegrasyonlar',
  storeSection: 'Mağaza',
  channelsSection: 'Kanallar',
  channelCount: '{used} / {limit} kanal',
  prerequisite: 'Gerekli: {prerequisite}',
  lastEvent: 'Son olay: {when}',
  lastFullSync: 'Son eşitleme: {when}',
  lastPriceReread: 'Fiyatlar son okundu: {when}',
  lastError: 'Son hata: {when}',
  egressIps: 'İzin listesine eklenecek IP adresleri: {ips}',
  storeEdition: '{platform} · {currency}',
  otherStreams: 'Diğer',
  reason: {
    billing_blocked: 'Meta hesabınızda ödeme yöntemi yok; ücretsiz mesaj hakkı doldu.',
    copy_only: 'Yönlendirme yalnızca kopya: başka bir uygulama yanıtlıyor, ESNAF AI gönderemiyor.',
    auth_expired: 'Bağlantının yeniden yetkilendirilmesi gerekiyor.',
    permission_missing: 'Verilen erişim yetersiz.',
    plan_prerequisite_missing: '{prerequisite} mağazanızda etkin değil.',
    unavailable: 'Platforma şu an ulaşılamıyor.',
  },
  capability: {
    echoes: 'Telefon yanıtları algılanır',
    historyImport: 'Geçmiş içe aktarıldı',
    automatedWindow: '{hours} saat otomatik yanıt',
    manualWindow7Days: '7 gün personel yanıtı',
    liveLookup: 'Anlık fiyat kontrolü',
    rawStreams: '+{count} ham akış',
    webhook: 'Webhook',
    polling: 'Yoklama: {seconds} sn',
    utm: 'Sipariş kaynağı (UTM)',
  },
  action: {
    reconnect: 'Yeniden bağlan',
    test: 'Test et',
    syncNow: 'Şimdi eşitle',
    log: 'Günlük',
    disconnect: 'Bağlantıyı kes',
  },
  disconnect: {
    title: '{name} bağlantısını kes',
    channel: 'Bu kanaldan mesaj alınmaz ve gönderilmez; konuşmalar panelde kalır.',
    store:
      'Mağazadan eşitleme durur; ürün kopyanız ve siparişleriniz silinmez, fiyatlar süre dolunca eski sayılır.',
  },
  log: {
    title: '{name} günlüğü',
    table: 'Eşitleme çalışmaları',
    empty: 'Henüz kayıt yok.',
    column: {
      type: 'Tür',
      trigger: 'Tetikleyen',
      status: 'Durum',
      streams: 'Akışlar',
      counts: 'Sayılar',
      errors: 'Hatalar',
      started: 'Başladı',
      duration: 'Süre',
    },
    count: '{stream}: {fetched} okundu, {changed} değişti, {failed} hatalı',
    errorCount: '{count} hata',
    runType: {
      full: 'Tam',
      incremental: 'Artımlı',
      event: 'Olay',
      reconcile: 'Uzlaştırma',
      price_reread: 'Fiyat okuma',
      remap: 'Yeniden eşleme',
    },
    trigger: {
      connect: 'Bağlantı',
      scheduler: 'Zamanlayıcı',
      event: 'Olay',
      merchant: 'İşletme',
      operator: 'Destek ekibi',
    },
    sendFailure: 'Gönderilemeyen mesaj',
  },
  // The WhatsApp pre-launch form of merchant screens §3.1 step 3 and §3.11.
  whatsapp: {
    prerequisite:
      "Bağlanmadan önce Meta Business Suite'te işletme hesabınıza bir ödeme yöntemi ekleyin; ödeme yöntemi olmadan mesaj gönderilemez.",
    billingLink: 'Meta Business Suite ödeme ayarları',
    // A constant of the string table, not an API field (§3.1 step 3).
    billingUrl: 'https://business.facebook.com/billing_hub/accounts',
    pin: "WhatsApp iki adımlı doğrulama PIN'i",
    pinHint:
      "Numaranızda iki adımlı doğrulama açıksa mevcut PIN'inizi yazın; değilse yeni bir 6 haneli PIN seçin.",
    consent:
      'Bu numara WhatsApp Business uygulamasında kullanılıyor; geçmiş sohbetlerin içe aktarılmasını kabul ediyorum',
    connect: 'Meta ile bağlan',
    notCompleted: 'Bağlantı tamamlanmadı.',
    retry: 'Tekrar dene',
    paymentWarning:
      "Meta hesabınızda ödeme yöntemi yok. Ücretsiz mesaj hakkı dolunca teslimat durur; Meta Business Suite'ten bir ödeme yöntemi ekleyin.",
  },
} as const satisfies CatalogTree;
